<template>
  <div>
    <!-- <Header /> -->
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="px-5 lg:px-10 mt-8 pb-4">
          <div
            class="flex flex-col-reverse md:flex-nowrap md:flex-row md:items-center md:justify-between gap-4"
          >
            <div>
              <h1 class="text-lg font-semibold">
                Assignments Submitted
                <span class="text-blue-600"> ({{ total_count || 0 }}) </span>
              </h1>
              <p class="text-xs text-slate-500 mt-1">
                Manage assignments and track Learner submissions.
              </p>
            </div>
            <div class="flex justify-end md:justify-normal">
              <router-link
                :to="{ name: 'InstructorAssignments' }"
                class="bg-blues hover:bg-hover text-xs font-bold text-white px-5 py-1.5 rounded-full"
                >Back</router-link
              >
            </div>
          </div>
          <div class="flex flex-col md:flex-row gap-4 mt-6 items-center">
            <div class="relative w-full md:max-w-80">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="searching"
                @input="getdetails()"
                placeholder="Search..."
                class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-xs text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                v-if="searching"
                @click="clearSearch"
                class="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div class="w-full">
              <div class="flex justify-end items-center">
                <div
                  class="flex rounded-lg border border-gray-200 overflow-hidden bg-white"
                >
                  <button
                    @click="setTab('list')"
                    :class="[
                      'px-3 py-2 text-sm transition-colors',
                      tab === 'list'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-500 hover:text-gray-700',
                    ]"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  </button>
                  <button
                    @click="setTab('card')"
                    :class="[
                      'px-3 py-2 text-sm transition-colors border-l border-gray-200',
                      tab === 'card'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-500 hover:text-gray-700',
                    ]"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="tab === 'list'" class="px-5 pb-4 lg:px-10">
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>
          <div
            v-else-if="assignment_list && assignment_list.length > 0"
            class="mt-5 space-y-4"
          >
            <div
              class="w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white"
            >
              <table
                class="min-w-full divide-y divide-gray-200 text-sm overflow-visible"
              >
                <thead class="bg-gray-50 text-textblues">
                  <tr class="whitespace-nowrap">
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-left border-b border-r border-gray-200"
                    >
                      Submitted By
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-left border-b border-r border-gray-200 w-[260px] lg:w-[300px] xl:w-[350px]"
                    >
                      Assignment Title
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                    >
                      Submitted At
                    </th>
                    <!--  <th
                          scope="col"
                          class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                        >
                      Submitted by
                    </th> -->
                    <!-- <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                    >
                      Description
                    </th> -->
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                    >
                      File
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                    >
                      Plagiarism Score
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200"
                    >
                      Grade Score
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-gray-200"
                    >
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody class="divide-y divide-gray-200 bg-white">
                  <tr
                    v-for="assignment in assignment_list"
                    :key="assignment"
                    class="hover:bg-gray-50/75 transition-colors duration-150"
                  >
                    <td
                      class="py-6 px-4 border-r border-gray-200 text-left text-gray-700"
                    >
                      <div class="flex justify-start items-center gap-2">
                        <div
                          class="w-7 h-7 flex-shrink-0 rounded-full uppercase bg-indigo-50 flex items-center justify-center text-[10px] font-bold text-indigo-600"
                        >
                          {{ assignment?.user?.display_name.charAt(0) || "?" }}
                        </div>
                        <div class="flex flex-col min-w-0">
                          <span
                            class="text-xs font-semibold text-slate-700 uppercase"
                          >
                            {{ assignment?.user?.display_name }}
                          </span>
                          <div
                            class="text-[12px] text-gray-500 flex items-center gap-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="12px"
                              viewBox="0 -960 960 960"
                              width="12px"
                              fill="#9CA3AF"
                            >
                              <path
                                d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                              />
                            </svg>
                            {{ assignment?.user?.email || "NA" }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="px-6 py-3 border-r border-gray-200">
                      <div
                        class="text-sm w-[260px] lg:w-[300px] xl:w-[350px] break-words"
                      >
                        <p
                          :class="{ 'line-clamp-2': expandedIndex !== index }"
                          class="text-gray-900 break-words"
                        >
                          {{ assignment.title }}
                        </p>

                        <div
                          v-if="
                            assignment.title && assignment.title.length > 100
                          "
                          class="mt-1"
                        >
                          <button
                            type="button"
                            @click.stop="toggleTitle(index)"
                            class="text-blue-600 text-xs font-semibold hover:text-blue-800 transition"
                          >
                            {{
                              expandedIndex === index
                                ? "Read Less ←"
                                : "Read More →"
                            }}
                          </button>
                        </div>
                      </div>
                    </td>
                    <td
                      class="px-6 py-3 whitespace-nowrap border-r border-gray-200 text-center"
                    >
                      <p class="text-xs text-gray-600 px-1">
                        {{ formatDate(assignment.created_at) || null }}
                      </p>
                    </td>

                    <!-- <td class="px-6 py-3 border-r border-gray-200 text-center">
                      <div class="flex justify-center">
                        <button
                          @click.stop="
                            openDescriptionModal(assignment.student_description)
                          "
                          class="flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 rounded-md hover:bg-blue-100 transition-all text-xs font-semibold shadow-sm"
                          title="View Full Description"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            />
                          </svg>
                          <span class="text-xs font-medium">View</span>
                        </button>
                      </div>
                    </td> -->
                    <td
                      class="px-6 py-3 border-r border-gray-200 text-center whitespace-nowrap"
                    >
                      <a
                        @click.stop
                        :href="assignment.file"
                        download
                        target="_blank"
                        class="inline-flex items-center gap-1.5 text-xs text-blue-600 hover:text-blue-800"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                          />
                        </svg>
                        Submitted Document
                      </a>
                    </td>

                    <td
                      class="px-6 py-3 text-gray-500 border-r border-gray-200 text-center text-xs"
                    >
                      <span
                        v-if="
                          assignment.plagiarismcheck != null &&
                          assignment.plagiarismcheck != ''
                        "
                      >
                        {{ assignment.plagiarismcheck }}
                      </span>
                      <span v-else> NA </span>
                    </td>
                    <td
                      class="px-6 py-3 text-gray-500 border-r border-gray-200 text-center text-xs"
                    >
                      <p class="px-1">
                        {{
                          assignment.verify_status === "accepted"
                            ? assignment.remark
                            : "NA"
                        }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-3 text-center"
                      @click="detailsPopup(assignment)"
                    >
                      <button
                        v-if="assignment.verify_status == 'submitted'"
                        class="px-3 rounded-xl bg-sky-800 hover:bg-hover py-1.5 text-xs text-white font-semibold"
                      >
                        Submitted
                      </button>
                      <button
                        v-else-if="assignment.verify_status == 'accepted'"
                        class="px-3 rounded-xl text-xs py-1.5 bg-teal-700 hover:bg-teal-800 text-white font-semibold"
                      >
                        Accepted
                      </button>
                      <button
                        v-else
                        class="text-xs px-3 py-1.5 rounded-xl bg-pink-700 hover:bg-pink-800 text-white font-semibold"
                      >
                        Rejected
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            v-else
            class="flex flex-col justify-center"
            style="height: calc(100vh - 500px) !important"
          >
            <p class="flex justify-center">No Data Found</p>
          </div>
        </div>

        <div v-else-if="tab === 'card'" class="pb-4">
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 500px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>
          <div
            v-else-if="assignment_list && assignment_list.length > 0"
            class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 px-5 lg:px-10 gap-10 mt-5"
          >
            <div
              v-for="assignment in assignment_list"
              :key="assignment"
              @click="detailsPopup(assignment)"
              class="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-md transition-shadow"
            >
              <div
                class="h-32 bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center"
              >
                <svg
                  class="w-12 h-12 text-white opacity-80"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>

              <div class="p-4 space-y-2 text-xs text-slate-600">
                <div class="truncate">
                  <span class="font-bold text-slate-700"
                    >Assignment Title:</span
                  >
                  {{ assignment.title || "NA" }}
                </div>
                <div class="truncate">
                  <span class="font-bold text-slate-700">Submitted Name:</span>
                  {{ assignment.user?.display_name || "NA" }}
                </div>
                <div class="truncate text-slate-500">
                  <span class="font-bold text-slate-700 text-xs"
                    >Submitted Email:</span
                  >
                  {{ assignment.user?.email || "NA" }}
                </div>
                <div class="truncate text-slate-500">
                  <span class="font-bold text-slate-700 text-xs"
                    >Grade Score:</span
                  >
                  {{
                    assignment.verify_status === "accepted"
                      ? assignment.remark
                      : "NA"
                  }}
                </div>

                <p class="truncate">
                  <span class="font-bold text-slate-700">Submitted At:</span>
                  {{ formatDate(assignment.created_at) || "NA" }}
                </p>

                <div class="flex justify-between pt-3">
                  <a
                    :href="assignment.file"
                    download
                    target="_blank"
                    class="inline-flex items-center gap-1.5 text-xs font-medium text-blue-600 hover:text-blue-800"
                  >
                    <svg
                      class="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                    Download
                  </a>
                  <div class="flex mx-1 gap-3">
                    <button
                      v-if="assignment.verify_status == 'submitted'"
                      class="px-3 rounded-xl bg-sky-800 hover:bg-hover py-1.5 text-xs text-white font-semibold"
                    >
                      Submitted
                    </button>
                    <button
                      v-else-if="assignment.verify_status == 'accepted'"
                      class="px-3 rounded-xl text-xs py-1.5 bg-teal-700 hover:bg-teal-800 text-white font-semibold"
                    >
                      Accepted
                    </button>
                    <button
                      v-else
                      class="text-xs px-3 py-1.5 rounded-xl bg-pink-700 hover:bg-pink-800 text-white font-semibold"
                    >
                      Rejected
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else
            class="flex flex-col justify-center"
            style="height: calc(100vh - 500px) !important"
          >
            <p class="flex justify-center">No Data Found</p>
          </div>
        </div>

        <div
          v-if="is_detailsPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="2xl:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px] w-[90%] mx-auto heightfix"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-textblues">Assignment</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-6"
                alt=""
                @click="(is_detailsPopup = false), (is_preview = false)"
              />
            </div>

            <div class="w-full mt-4 border border-gray-100 rounded-2xl p-6">
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <!-- Left Column -->
                <div class="flex flex-col gap-4">
                  <div class="flex flex-col gap-2">
                    <p class="text-sm font-semibold text-gray-700">Title</p>
                    <p class="text-sm text-gray-600">
                      {{ assignmentDetails.title }}
                    </p>
                  </div>

                  <!-- <div class="flex flex-col gap-2">
                    <p class="text-sm font-semibold text-gray-700">
                      Description
                    </p>
                    <p class="text-sm text-gray-600 whitespace-pre-wrap">
                      {{ assignmentDetails.student_description || "NA" }}
                    </p>
                  </div> -->

                  <div>
                    <a :href="assignmentDetails.file" target="_blank">
                      <button
                        class="bg-blues hover:bg-hover px-4 py-2 rounded-lg text-white font-semibold text-sm"
                      >
                        Download Submitted Document
                      </button>
                    </a>
                  </div>

                  <!-- Accept / Reject -->
                  <div
                    v-if="assignmentDetails.verify_status == 'submitted'"
                    class="flex flex-wrap gap-4"
                  >
                    <button
                      @click="open_accept_pop = true"
                      class="flex items-center gap-2 bg-green-700 hover:bg-green-800 text-white px-4 py-1 rounded-lg"
                    >
                      <font-awesome-icon :icon="['fas', 'check-circle']" />
                      <span>Accept</span>
                    </button>

                    <button
                      @click="open_rejected_pop = true"
                      class="flex items-center gap-2 bg-red-700 hover:bg-red-800 text-white px-4 py-1 rounded-lg"
                    >
                      <font-awesome-icon :icon="['fas', 'times-circle']" />
                      <span>Reject</span>
                    </button>
                  </div>

                  <!-- Validated Status -->
                  <div v-else class="bg-gray-50 rounded-xl p-4">
                    <div class="flex justify-between items-center mb-3">
                      <h1 class="font-bold text-base">Already Validated</h1>

                      <button
                        @click="openEditValidation"
                        class="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition"
                        title="Edit Validation"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-4 h-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.586-9.414a2 2 0 112.828 2.828L12 15l-4 1 1-4 8.414-8.414z"
                          />
                        </svg>
                      </button>
                    </div>
                    <p class="text-sm font-semibold">
                      Status :
                      <span
                        :class="
                          assignmentDetails.verify_status === 'rejected'
                            ? 'text-red-600'
                            : 'text-green-600'
                        "
                      >
                        {{ assignmentDetails.verify_status }}
                      </span>
                    </p>

                    <p class="text-sm mt-2">
                      <span class="font-semibold">
                        {{
                          assignmentDetails.verify_status === "accepted"
                            ? "Grade:"
                            : "Remark:"
                        }}
                      </span>

                      {{ assignmentDetails.remark || "NA" }}
                    </p>
                    <p
                      class="text-sm font-semibold mt-2"
                      v-if="assignmentDetails.verify_status === 'accepted'"
                    >
                      Feedback :
                      <span class=" font-normal">
                        {{ assignmentDetails.feedback }}
                      </span>
                    </p>
                  </div>
                </div>

                <!-- Right Column - Document Preview -->
                <div
                  class="border rounded-xl bg-white overflow-hidden shadow-sm"
                >
                  <!-- Header -->
                  <div class="px-4 py-3 border-b bg-gray-50">
                    <h3 class="font-semibold text-gray-700">
                      Submitted Document Preview
                    </h3>
                  </div>

                  <!-- Content -->
                  <div class="h-[400px] overflow-auto">
                    <!-- No File -->
                    <div
                      v-if="!assignmentDetails?.file"
                      class="h-full flex flex-col items-center justify-center gap-2"
                    >
                      <!-- <img
                        src="@/assets/new/no-data.png"
                        alt="No File"
                        class="w-20 h-20 object-contain opacity-50"
                      /> -->
                      <p class="text-gray-500 text-sm">No file available</p>
                    </div>

                    <!-- PDF -->
                    <iframe
                      v-else-if="isPdf"
                      :src="assignmentDetails.file"
                      class="w-full h-full border-0"
                    ></iframe>

                    <!-- Image -->
                    <div
                      v-else-if="isImage"
                      class="flex justify-center items-center min-h-full p-4 bg-gray-50"
                    >
                      <img
                        :src="assignmentDetails.file"
                        class="max-w-full max-h-[380px] object-contain rounded-lg"
                      />
                    </div>

                    <!-- DOC / DOCX / XLS / XLSX / PPT -->
                    <iframe
                      v-else-if="isOfficeFile && officeViewerUrl"
                      :src="officeViewerUrl"
                      class="w-full h-full border-0"
                    ></iframe>

                    <!-- CSV -->
                    <div v-else-if="isCsv" class="h-full overflow-auto">
                      <table
                        v-if="csvHeaders.length"
                        class="min-w-full border-collapse"
                      >
                        <thead class="sticky top-0 bg-gray-100 z-10">
                          <tr>
                            <th
                              v-for="(header, index) in csvHeaders"
                              :key="index"
                              class="border px-3 py-2 text-left text-sm font-semibold whitespace-nowrap"
                            >
                              {{ header }}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(row, rowIndex) in csvRows"
                            :key="rowIndex"
                            class="hover:bg-gray-50"
                          >
                            <td
                              v-for="(cell, cellIndex) in row"
                              :key="cellIndex"
                              class="border px-3 py-2 text-sm whitespace-nowrap"
                            >
                              {{ cell }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div
                        v-else
                        class="h-full flex items-center justify-center"
                      >
                        <p class="text-gray-500">Loading CSV...</p>
                      </div>
                    </div>

                    <!-- Unsupported Files -->
                    <div
                      v-else
                      class="h-full flex flex-col items-center justify-center gap-4"
                    >
                      <p class="text-gray-500 text-sm text-center">
                        Preview is not available for this file type.
                      </p>

                      <a
                        :href="assignmentDetails.file"
                        target="_blank"
                        class="bg-blues hover:bg-hover text-white px-4 py-2 rounded-lg text-sm font-medium"
                      >
                        Download File
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="this.open_rejected_pop == true || this.open_accept_pop == true"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
    >
      <div
        class="w-full max-w-3xl bg-white rounded-3xl shadow-2xl overflow-hidden"
      >
        <div class="px-4 py-3 border-b border-gray-200">
          <div class="flex items-start justify-between gap-3">
            <!-- Left Content -->
            <div>
              <h2 class="text-lg font-semibold text-gray-900">
                {{
                  open_accept_pop ? "Accept Assignment" : "Reject Assignment"
                }}
              </h2>

              <p class="text-xs text-gray-500 mt-1">
                {{
                  open_accept_pop
                    ? "Provide grade and feedback"
                    : "Provide rejection remarks"
                }}
              </p>
            </div>

            <!-- Close Icon -->
            <button
              type="button"
              @click="
                open_rejected_pop = false;
                open_accept_pop = false;
                grade = '';
                remarks = '';
                feedback = '';
              "
              class="flex items-center justify-center w-8 h-8 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        <form ref="createTeamRef" @submit.prevent="submitResult" class="p-6">
          <!-- Accept -->
          <div v-if="open_accept_pop" class="grid lg:grid-cols-2 gap-6">
            <!-- Form -->
            <div class="space-y-5">
              <!-- Grade -->
              <div>
                <label
                  class="flex items-center justify-between text-sm font-semibold text-slate-700 mb-2"
                >
                  <span> Grade Score <span class="text-red-500">*</span></span>

                  <span
                    class="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-700"
                  >
                    0 - 10
                  </span>
                </label>

                <input
                  v-model.number="grade"
                  type="number"
                  min="0"
                  max="10"
                  required
                  @input="validateScore"
                  placeholder="Enter grade score"
                  class="w-full border border-slate-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                />
              </div>

              <!-- Feedback -->
              <div>
                <label class="block text-sm font-semibold text-slate-700 mb-2">
                  Feedback <span class="text-red-500">*</span>
                </label>

                <textarea
                  v-model="feedback"
                  rows="3"
                  required
                  placeholder="Enter feedback"
                  class="w-full border border-slate-300 rounded-xl p-4 resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                ></textarea>
              </div>
            </div>

            <!-- Instructions -->
            <div class="bg-blue-50 border border-blue-100 rounded-2xl p-5">
              <h3 class="text-lg font-semibold text-blue-900 mb-2">
                Instructions
              </h3>

              <div class="space-y-2 text-sm text-slate-600">
                <div class="flex gap-3">
                  <span class="text-blue-600">✓</span>
                  <span>Enter score between 0 and 10.</span>
                </div>

                <div class="flex gap-3">
                  <span class="text-blue-600">✓</span>
                  <span>Provide useful feedback.</span>
                </div>

                <div class="flex gap-3">
                  <span class="text-blue-600">✓</span>
                  <span>Students can view the result.</span>
                </div>

                <div class="flex gap-3">
                  <span class="text-blue-600">✓</span>
                  <span>Feedback helps student improvement.</span>
                </div>
              </div>

              <div class="mt-5 rounded-xl bg-white border border-blue-200 p-4">
                <p class="text-sm text-blue-700">
                  After submission, the assignment will be marked as accepted.
                </p>
              </div>
            </div>
          </div>

          <!-- Reject -->
          <div v-if="open_rejected_pop" class="space-y-5">
            <div class="rounded-xl border border-red-100 bg-red-50 p-4">
              <p class="text-sm text-red-600">
                Please provide a reason for rejection. This message will be
                shown to the student.
              </p>
            </div>

            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">
                Remarks <span class="text-red-500">*</span>
              </label>

              <textarea
                v-model="remarks"
                rows="3"
                required
                placeholder="Enter rejection remarks"
                class="w-full border border-slate-300 rounded-xl p-4 resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              ></textarea>
            </div>
          </div>

          <!-- Footer -->
          <div
            class="flex flex-col-reverse sm:flex-row justify-end gap-3 border-t mt-8 pt-5"
          >
            <button
              type="button"
              @click="
                open_rejected_pop = false;
                open_accept_pop = false;
                this.grade = '';
                this.remarks = '';
                this.feedback = '';
              "
              class="px-6 py-1.5 rounded-xl border border-slate-300 text-slate-600 hover:bg-slate-100"
            >
              Cancel
            </button>

            <button
              type="submit"
              :disabled="disable_submit"
              :class="
                disable_submit
                  ? 'bg-gray-200 text-black cursor-not-allowed'
                  : 'bg-blues hover:bg-hover cursor-pointer text-white'
              "
              class="px-8 py-1.5 rounded-xl font-semibold flex items-center justify-center gap-2"
            >
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                class="w-5 h-5"
              />

              {{ open_accept_pop ? "Accept" : "Reject" }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Edit Validation Modal -->
    <div
      v-if="showEditValidation"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
    >
      <div
        class="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden"
      >
        <!-- Header -->
        <div class="px-4 py-3 border-b border-gray-200">
          <div class="flex items-start justify-between gap-3">
            <!-- Left -->
            <div>
              <h2 class="text-lg font-semibold text-gray-900">
                Update Validation
              </h2>

              <p class="text-xs text-gray-500 mt-1">
                Update assignment verification details.
              </p>
            </div>

            <!-- Close -->
            <button
              type="button"
              @click="showEditValidation = false"
              class="flex items-center justify-center w-8 h-8 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Body -->
        <div class="p-5">
          <!-- Status -->
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Validation Status
            </label>

            <select
              v-model="verify_status"
              class="w-full border border-slate-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            >
              <option value="accepted">Accept</option>
              <option value="rejected">Reject</option>
            </select>
          </div>

          <!-- Accepted -->
          <div v-if="verify_status === 'accepted'" class="space-y-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Grade Score
              </label>

              <input
                v-model="grade"
                type="number"
                min="0"
                max="10"
                @input="validateScore"
                placeholder="Enter Grade Score (0-10)"
                class="w-full border border-slate-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              />

              <p v-if="gradeError" class="text-red-500 text-xs mt-1">
                {{ gradeError }}
              </p>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Feedback
              </label>

              <textarea
                v-model="feedback"
                rows="3"
                placeholder="Enter feedback"
                class="w-full border border-slate-300 rounded-xl p-3 resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
              ></textarea>
            </div>
          </div>

          <!-- Rejected -->
          <div v-else class="space-y-4">
            <div class="rounded-xl border border-red-100 bg-red-50 p-3">
              <p class="text-sm text-red-600">
                Please provide a reason for rejection.
              </p>
            </div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Remarks
            </label>
            <textarea
              v-model="remarks"
              rows="3"
              placeholder="Enter rejection remarks"
              class="w-full border border-slate-300 rounded-xl p-3 resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            ></textarea>

            <p v-if="remarkError" class="text-red-500 text-xs">
              {{ remarkError }}
            </p>
          </div>

          <!-- Footer -->
          <div class="flex justify-end gap-3 border-t mt-5 pt-4">
            <button
              type="button"
              @click="showEditValidation = false"
              class="px-5 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100"
            >
              Cancel
            </button>

            <button
              @click="updateValidation"
              :disabled="disable_submit"
              :class="
                disable_submit
                  ? 'bg-gray-200 text-black cursor-not-allowed'
                  : 'bg-blues hover:bg-hover text-white'
              "
              class="px-5 py-2 rounded-lg font-medium flex items-center gap-2"
            >
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-5 h-5"
              />

              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="descriptionModalOpen"
      class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4"
    >
      <div
        class="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-hidden flex flex-col relative"
      >
        <!-- Modal Header -->
        <div
          class="flex items-center justify-between p-5 border-b border-gray-200"
        >
          <h2 class="text-xl font-semibold text-gray-800">
            Assignments Submitted Description
          </h2>
          <button
            @click="descriptionModalOpen = false"
            class="text-gray-500 hover:text-red-500 text-2xl"
          >
            &times;
          </button>
        </div>
        <!-- Modal Body -->
        <div
          v-if="currentDescription"
          class="p-6 overflow-y-auto text-gray-700 text-sm leading-relaxed whitespace-pre-wrap"
        >
          {{ currentDescription }}
        </div>
        <div v-else class="p-6 text-center">No Data Found</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import VuePdfEmbed from "vue-pdf-embed";

export default {
  components: {
    Header,
    SideBar,
    VuePdfEmbed,
    FlashMessage,
  },
  data() {
    return {
      showEditValidation: false,
      verify_status: "",
      descriptionModalOpen: false,
      currentDescription: "",
      assignment_list: "",
      is_detailsPopup: false,
      // assignmentDetails: null,
      assignmentDetails: {},
      messages: {
        text: "",
        type: "null",
      },
      is_preview: false,
      open_accept_pop: false,
      open_rejected_pop: false,
      grade: null,
      remarks: "",
      feedback: "",
      tab: "list",
      disable_submit: false,
      total_count: 0,
      searching: "",
      csvHeaders: [],
      csvRows: [],
      loading: true,
      expandedIndex: null,
      gradeError: "",
      remarkError: "",
    };
  },
  created() {
    this.getdetails();
  },

  props: ["course_id", "assignment_id"],
  watch: {
    "assignmentDetails.file": {
      immediate: true,
      handler() {
        this.csvHeaders = [];
        this.csvRows = [];

        if (this.isCsv) {
          this.loadCsvPreview();
        }
      },
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
    fileExtension() {
      const file = this.assignmentDetails?.file;

      if (!file) return "";

      return file.split(".").pop().toLowerCase().split("?")[0];
    },

    isPdf() {
      return this.fileExtension === "pdf";
    },

    isImage() {
      return ["jpg", "jpeg", "png", "gif", "webp"].includes(this.fileExtension);
    },

    isCsv() {
      return this.fileExtension === "csv";
    },

    isOfficeFile() {
      return ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(
        this.fileExtension,
      );
    },

    officeViewerUrl() {
      const file = this.assignmentDetails?.file;

      if (!file) return "";

      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        file,
      )}`;
    },
  },
  methods: {
    openEditValidation() {
      this.showEditValidation = true;

      this.verify_status = this.assignmentDetails.verify_status;

      if (this.verify_status === "accepted") {
        this.grade = this.assignmentDetails.remark;
        this.feedback = this.assignmentDetails.feedback;
      } else {
        this.remarks = this.assignmentDetails.remark;
      }
    },

    async updateValidation() {
      this.gradeError = "";
      this.remarkError = "";
      if (this.verify_status === "accepted") {
        if (
          this.grade === "" ||
          this.grade === null ||
          this.grade === undefined
        ) {
          this.gradeError = "Grade Score is required";
          setTimeout(() => {
            this.gradeError = "";
          }, 3000);
          return;
        }
        await this.accept();
      } else if (this.verify_status === "rejected") {
        if (!this.remarks || !this.remarks.trim()) {
          this.remarkError = "Remark is required";
          setTimeout(() => {
            this.remarkError = "";
          }, 3000);
          return;
        }
        await this.reject();
      }
      this.showEditValidation = false;
    },
    validateScore(event) {
      let value = event.target.value;

      value = value.replace(/\D/g, "");

      value = value.slice(0, 2);

      if (value !== "") {
        value = Math.min(10, Math.max(0, Number(value)));
      }

      this.grade = value;
      event.target.value = value;
    },
    toggleTitle(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
    async loadCsvPreview() {
      if (!this.isCsv || !this.assignmentDetails.file) return;

      try {
        const response = await fetch(this.assignmentDetails.file);
        const csvText = await response.text();

        const rows = csvText.split(/\r?\n/).filter((row) => row.trim() !== "");

        if (rows.length) {
          this.csvHeaders = rows[0].split(",").map((item) => item.trim());

          this.csvRows = rows
            .slice(1)
            .map((row) => row.split(",").map((item) => item.trim()));
        }
      } catch (error) {
        console.error("CSV Preview Error:", error);
      }
    },
    openDescriptionModal(description) {
      this.currentDescription = description;
      this.descriptionModalOpen = true;
    },
    showMore(index) {
      this.assignmentInfo.data[index].visibleLengths += 50;
    },
    showLess(index) {
      // this.assignmentInfo.data[index].visibleLengths -= 100;
      this.assignmentInfo.data[index].visibleLengths = 50;
    },
    setTab(view) {
      this.tab = view;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    convertHttpToHttps(url) {
      if (url.startsWith("http://")) {
        return url.replace("http://", "https://");
      }
      return url; // If it's already https or any other scheme, return as is
    },
    submitResult() {
      if (this.open_accept_pop) {
        this.accept();
      } else if (this.open_rejected_pop) {
        this.reject();
      }
    },
    async accept() {
      try {
        this.disable_submit = true;

        const acceptsVal = {
          user: this.assignmentDetails.user.id,
          assignment_id: this.assignmentDetails.assignment_id,
          title: this.assignmentDetails.title,
          student_description: this.assignmentDetails.student_description,
          submit_date: this.assignmentDetails.submit_date,
          verify_status: "accepted",
          remark: this.grade,
          feedback: this.feedback,
        };

        const response = await axios.put(
          `${process.env.VUE_APP_API}/student_assignment/updated/${this.assignmentDetails.id}/?Key=${this.userInfo.token_key}`,
          acceptsVal,
        );

        if (response.data.status === 200) {
          this.messages = {
            text: "Assignment Accepted Successfully",
            type: "success",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
            this.is_detailsPopup = false;
            this.open_accept_pop = false;
            this.grade = null;
            this.feedback = "";
            this.getdetails();
          }, 1500);
        } else {
          this.messages = {
            text: "Assignment Acceptance Failed",
            type: "error",
          };
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 1500);
        }
      } catch (error) {
        console.error(error);
        this.messages = {
          text: "Something went wrong",
          type: "error",
        };
      } finally {
        setTimeout(() => {
          this.disable_submit = false;
        }, 1500);
      }
    },

    async reject() {
      try {
        this.disable_submit = true;

        const rejectedVal = {
          user: this.assignmentDetails.user.id,
          assignment_id: this.assignmentDetails.assignment_id,
          title: this.assignmentDetails.title,
          student_description: this.assignmentDetails.student_description,
          submit_date: this.assignmentDetails.submit_date,
          verify_status: "rejected",
          remark: this.remarks,
        };

        const response = await axios.put(
          `${process.env.VUE_APP_API}/student_assignment/updated/${this.assignmentDetails.id}/?Key=${this.userInfo.token_key}`,
          rejectedVal,
        );

        if (response.data.status === 200) {
          this.messages = {
            text: "Assignment Rejected Successfully",
            type: "success",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
            this.is_detailsPopup = false;
            this.open_rejected_pop = false;
            this.remarks = "";
            this.getdetails();
          }, 1500);
        } else {
          this.messages = {
            text: "Assignment Rejection Failed",
            type: "error",
          };
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 1500);
        }
      } catch (error) {
        console.error(error);
        this.messages = {
          text: "Something went wrong",
          type: "error",
        };
      } finally {
        setTimeout(() => {
          this.disable_submit = false;
        }, 1500);
      }
    },
    detailsPopup(value) {
      this.is_detailsPopup = true;
      this.assignmentDetails = value;
    },
    clearSearch() {
      this.searching = "";
      this.getdetails();
    },
    async getdetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/assignment/list/view/?assignment_id=${this.assignment_id}&Key=${this.userInfo.token_key}&search=${this.searching}`,
        )
        .then((response) => {
          console.log(response);
          if (response.data.message == "No details found") {
            console.log("Null");
            this.assignment_list = null;
          } else {
            this.assignment_list = response.data;
            this.total_count = response.data.count;

            console.log("this.assignment_list", this.assignment_list);
            // this.assignment_list.data.forEach((element) => {
            //   console.log(element.title);
            //   element["display_date"] = new Date(
            //     element.submit_date
            //   ).toLocaleDateString("en-IN", {
            //     day: "numeric",
            //     month: "long",
            //     year: "numeric",
            //   });
            // });

            this.assignment_list = this.assignment_list.data;
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
